import { Flex, Dialog, CloseIcon } from "@fluentui/react-northstar";
import React from "react";

import { ConnectedAudioTestView } from "../../audio-test/audio-test-view/ConnectedAudioTestView";

import { DesktopAudioTestModalProps } from "./ResultsDesktopAudioTestModal.types";
import { useResultsDesktopAudioTestModal } from "./ResultsDesktopAudioTestModal.styles";

export const ResultsDesktopAudioTestModal: React.FC<DesktopAudioTestModalProps> =
  ({ exitAudioTestFlow, isModalOpen }) => {
    const desktopAudioTestModalStyles = useResultsDesktopAudioTestModal();

    return (
      <Dialog
        headerAction={{
          icon: <CloseIcon data-testid="closeDesktopAudioTest" />,
          onClick: exitAudioTestFlow,
          styles: desktopAudioTestModalStyles.closeButton,
        }}
        styles={desktopAudioTestModalStyles.audioDesktopDialogContainer}
        open={isModalOpen}
        content={
          <Flex styles={desktopAudioTestModalStyles.audioDesktopDialogContent}>
            <ConnectedAudioTestView />
          </Flex>
        }
      />
    );
  };
